import axios from 'axios'

export default axios.create({
  baseURL: 'https://nc.server.jsnwu.com/pages',
})
